import { render, staticRenderFns } from "./RoomBase.vue?vue&type=template&id=53d67d4a"
import script from "./RoomBase.vue?vue&type=script&lang=js"
export * from "./RoomBase.vue?vue&type=script&lang=js"
import style0 from "./RoomBase.vue?vue&type=style&index=0&id=53d67d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports